import { ReactNode } from 'react';
import { Button, IconProps } from '@cloudscape-design/components';
import { useTranslate } from 'src/i18n/useTranslate';
import './info-page-template.scss';

type InfoPageTemplateProps = {
    children: ReactNode;
    icon: ReactNode;
    headerText: string;
    buttonProps: {
        iconName: IconProps.Name;
        onClick: () => void;
        text: string;
    };
};

const InfoPageTemplate = ({
    children,
    headerText,
    icon,
    buttonProps: { iconName, onClick, text },
}: InfoPageTemplateProps) => {
    const t = useTranslate();

    return (
        <div>
            <div className={'info-page-container'}>
                <div className="info-page-icon">{icon}</div>
                <h1>{headerText}</h1>
                <div className="info-page-body">{children}</div>
                <Button iconName={iconName} onClick={onClick}>
                    {text}
                </Button>
            </div>
        </div>
    );
};

export default InfoPageTemplate;
